import { FormGroup } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { Injectable, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';

import swal from 'sweetalert2';
import { CalendarioPagoModel } from "@/store/catalogos/calendarioPago.model";
import { DatePipe } from "@angular/common";
import { ColaboradorModel } from "@/store/catalogos/colaborador.model";

@Injectable({
  providedIn: 'root'
})
export class Util {

  constructor(
     private toastr: ToastrService
    ,private datePipe:DatePipe
    ,private router: Router) {
  }

  public static validateReactiveField(campo: string, form: FormGroup) {
    return form.controls[campo].errors && form.controls[campo].touched;
  }

  public errorMessage(message: string) {
    this.toastr.error(message);
  }

  public successMessage(message: string) {
    this.toastr.success(message);
  }

  public puntearTexto(texto, longitud){
    return texto.length>=longitud;
    return texto;
  }

  public lpad(num:number, size:number): string {
    let s = num+"";
    while (s.length < size) s = "0" + s;
    return s;
  }

  public confirmMessage(message: string, do_) {
    swal.fire({
      title: message,
      showDenyButton: true,
      //showCancelButton: true,
      icon:'info',
      confirmButtonText: 'Si',
      denyButtonText: 'No',
      customClass: {
        actions: 'my-actions',
        cancelButton: 'order-1 right-gap',
        confirmButton: 'order-2',
        //denyButton: 'order-3',
      }
    }).then((result) => {
      if (result.isConfirmed) {
        do_();
        //swal.fire('Saved!', '', 'success')
      } //else if (result.isDenied) {
      //swal.fire('Changes are not saved', '', 'info')
      //}
    })
  }

  public infoMessage(title,message: string, do_) {
    swal.fire({
      title: title,
      html:message,
      //showDenyButton: true,
      //showCancelButton: true,
      confirmButtonText: 'Entendido',
      icon:'info',
      customClass: {
        actions: 'my-actions',
        cancelButton: 'order-1 right-gap',
        confirmButton: 'order-2',
        //denyButton: 'order-3',
      }
    }).then((result) => {
      if (result.isConfirmed) {
        do_();
        //swal.fire('Saved!', '', 'success')
      } //else if (result.isDenied) {
      //swal.fire('Changes are not saved', '', 'info')
      //}
    })
  }
   
  public autoOcultarMenu(renderer: Renderer2){
    const autoOcultarMenu = JSON.parse(localStorage.getItem("autoOcultarMenu"));
    if(autoOcultarMenu){
        //renderer.removeClass(document.querySelector('app-root'),'sidebar-open');
        //renderer.addClass(document.querySelector('app-root'),'sidebar-collapse');
        this.ocultarMenu(renderer);
    }
  }
   
  public ocultarMenu(renderer: Renderer2){
      renderer.removeClass(document.querySelector('app-root'),'sidebar-open');
      renderer.addClass(document.querySelector('app-root'),'sidebar-collapse');
  }

  public isEmpty(val) {
    return val == undefined || val == null || val == "";
  }

  public isTrue(val){
    return val==true || val==1 || val=='1';
  }

  public nvl(val1, val2):any {
    return this.isEmpty(val1) ? val2 : val1;
  }

  public calcularIva(importe:number):any {
    return (importe*1.16)-importe;
  }

  public validaFecha(fecha: string): boolean {
    return fecha.match("[0-9]{2}[/]{1}[0-9]{2}[/]{1}[0-9]{4}") != null;
  }
  // calcula la edad.
  public calculateAge(fechaNacimiento: Date): number {
    var timeDiff = Math.abs(Date.now() - fechaNacimiento.getTime());
    let age = Math.ceil((timeDiff / (1000 * 3600 * 24)) / 365);
    if(isNaN(age)){
      return null;
    }
    return age;
  }

  public static getNumbers(p: string) {
    return p?.replace(/[^0-9]+/g, "");
  }

  // cuenta los días habiles, no cuenta los 5 sabados y 6 domingos
  public workingDays(startingDate: Date, endDate: Date): number {
    let workingDays = 0;
    const day = 24 * 60 * 60 * 1000;
    while (startingDate <= endDate) {
      const week = startingDate.getDay();
      if (week !== 5 && week !== 6) {
        workingDays++;
      }
      startingDate.setTime(startingDate.getTime() + day);
    }
    return workingDays;
  }

  isValiField(field: string, form: FormGroup): boolean | null {
    return form.controls[field].errors
      && form.controls[field].touched;
  }

  getFieldError(field: string, form: FormGroup): string | null {
    if (!form.controls[field]) return null;
    const errors = form.controls[field].errors || {};

    for (const key of Object.keys(errors)) {
      switch (key) {
        case 'required':
          return 'Este campo es requerido';
        case 'minlength':
          return `Mínimo ${errors['minlength'].requiredLength} caracters.`;
      }

    }
  }

  toNumber(p:any):Number|null|undefined{
    return Number(p);
  }

  stringify(data){
    return JSON.stringify(data);
  }

  jsonParse(data){
    return JSON.parse(data);
  }

  isEmail(email: string):boolean {
    let isValid = false;
      'use strict';
      var REGEX = /^[a-zA-Z0-9.!#$%&’+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)$/;
      if (email.match(REGEX)){
        isValid = true;
      }
    return isValid;
  }

  isRfc(rfc: string):boolean {
    let isValid = false;
      'use strict';
      var REGEX = /^([A-ZÑ&]{3,4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/;
      if (rfc.match(REGEX)){
        isValid = true;
      }
    return isValid;
  }

  normalize(str:string|undefined) {
    return this.nvl(str,"").normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }

  private calcularCalendarioPagos(_duracionEspecialidad ,_costoEspecialidad
                         ,_fechaInicioClases    ,_fecha_inicio_grupo
                         ,tipoPago:string):CalendarioPagoModel[]{
    let TIMEZONE = "T09:00:00.000+06:00";
    let listaPagos:CalendarioPagoModel[] = [];
    let costo = 0;
    let noMesesPago:number = 0;

    switch(tipoPago){
      case 'CONTADO':
        noMesesPago = _duracionEspecialidad;
        break;
      case 'SEMESTRE':
        noMesesPago = 6;
        break;
      case 'TRIMESTRE':
        noMesesPago = 3;
        break;
      case 'DIFERIDO':
        noMesesPago = 1;
        break;
      default:
        noMesesPago = 1;
        break;            
    }

    let fecha_inicio_alumno = new Date(_fechaInicioClases+TIMEZONE);
    //let fecha_inicio_grupo = new Date(_fecha_inicio_grupo);
    //let totPagos = Math.trunc(_duracionEspecialidad / noMesesPago);
    let diaDelMesPago = fecha_inicio_alumno.getUTCDate();
    let pagoPorMes = _costoEspecialidad / _duracionEspecialidad;
    //let totalPagoParcialidad = _costoEspecialidad / totPagos;

    let mesesRestantes = _duracionEspecialidad;
    let cantidadPago = pagoPorMes*noMesesPago;
    let noPago = 1;
    let fechaPago = fecha_inicio_alumno;
    //INGRESAR DIA DEL MES DE PAGO
    fechaPago.setDate(diaDelMesPago);
    //AGREGAR PAGO A LA LISTA
    let pagoNuevo = {
      no_pago    : noPago,
      fecha_pago : this.datePipe.transform(fechaPago,'Y-MM-dd'),
      cantidad   : cantidadPago
    };

    listaPagos.push(pagoNuevo);
    //restar los meses del pago 
    
    costo+=cantidadPago;

    for(let i = noMesesPago; i<_duracionEspecialidad ; i+=noMesesPago){

      noPago++;
      let pagoAnterior=Object.assign({},pagoNuevo);
      //CALCULAR TOTAL DE PAGO PERIODO
      mesesRestantes=mesesRestantes-noMesesPago;
      cantidadPago = pagoPorMes*noMesesPago;

      let nuevoMes = 0;
      if(mesesRestantes<noMesesPago){
        nuevoMes = (fechaPago.getMonth() + mesesRestantes);
      }else{
        nuevoMes = (fechaPago.getMonth() + noMesesPago);
      }
      
      let fechaPagoAuxiliar = new Date(pagoAnterior.fecha_pago+TIMEZONE);
      fechaPagoAuxiliar.setMonth(nuevoMes-1);
      let numDiasMes = new Date(fechaPagoAuxiliar.getFullYear(), fechaPagoAuxiliar.getMonth(), 0).getDate();

      let _diaDelMesPago = 0;
      if(numDiasMes<diaDelMesPago){
        _diaDelMesPago = numDiasMes;
      }else{
        _diaDelMesPago = diaDelMesPago;
      }
      
      if(mesesRestantes<noMesesPago){
        cantidadPago = pagoPorMes * mesesRestantes;
      }
      let fecha = fechaPagoAuxiliar.getFullYear()+"-"+(nuevoMes+"".length==1?"0"+nuevoMes:nuevoMes)+"-"+(diaDelMesPago)+TIMEZONE;
      fechaPago = new Date(fecha);
      
      pagoNuevo = {
        no_pago    : noPago,
        fecha_pago : this.datePipe.transform(fechaPago,'Y-MM-dd'),
        cantidad   : cantidadPago
      };
      listaPagos.push(pagoNuevo);
      costo+=cantidadPago;

    }
    return listaPagos;
  }
  
  getSesion():ColaboradorModel{
    // Primero intentar obtener de 'usuario', luego de 'colaborador' para retrocompatibilidad
    const usuarioStr = sessionStorage.getItem('usuario');
    if (usuarioStr) {
      try {
        const usuario = JSON.parse(usuarioStr);
        // Si el usuario tiene colaborador asociado, retornarlo
        return usuario.colaborador || usuario;
      } catch (e) {
        console.error('Error al parsear usuario:', e);
      }
    }
    
    // Fallback a colaborador para retrocompatibilidad
    const colaboradorStr = sessionStorage.getItem('colaborador');
    if (colaboradorStr) {
      return JSON.parse(colaboradorStr);
    }
    
    return null;
  }
  
  setSesion(data:ColaboradorModel){
    // Guardar en 'colaborador' para retrocompatibilidad
    sessionStorage.setItem("colaborador", JSON.stringify(data));
    
    // Actualizar también en 'usuario' si existe
    const usuarioStr = sessionStorage.getItem('usuario');
    if (usuarioStr) {
      try {
        const usuario = JSON.parse(usuarioStr);
        if (usuario.colaborador) {
          // Actualizar el objeto colaborador completo
          usuario.colaborador = data;
        } else {
          // Si no tiene colaborador, actualizar el usuario directamente
          Object.assign(usuario, data);
        }
        sessionStorage.setItem('usuario', JSON.stringify(usuario));
      } catch (e) {
        console.error('Error al actualizar usuario en setSesion:', e);
      }
    }
  }

  horaSinSegundos(hora){
    if(this.isEmpty(hora)){
      return '';
    }
    return hora.substring(0,5);
  }

  /**
   * Verifica si el usuario tiene acceso a la ruta actual
   * @param rutaActual - Ruta actual a verificar (ej: '/catalogos/empresa')
   * @param redirigirSiNoTieneAcceso - Si es true, redirige a /dashboard cuando no tiene acceso
   * @returns true si tiene acceso, false si no
   */
  verificarAccesoPantalla(rutaActual: string, redirigirSiNoTieneAcceso: boolean = false): boolean {
    // Obtener el menú del usuario desde localStorage
    const menuStr = localStorage.getItem('menu');
    
    if (!menuStr) {
      console.warn('[Util] No hay menú en localStorage');
      if (redirigirSiNoTieneAcceso) {
        this.toastr.warning('No se pudo cargar el menú del usuario');
        this.router.navigate(['/dashboard']);
      }
      return false;
    }

    try {
      const menu = JSON.parse(menuStr);
      
      // Normalizar la ruta (eliminar trailing slash, query params, etc.)
      const rutaNormalizada = this.normalizarRuta(rutaActual);
      
      // Buscar la ruta en el menú
      const tieneAcceso = this.buscarRutaEnMenu(menu, rutaNormalizada);
      
      if (!tieneAcceso) {
        console.warn('[Util] Usuario no tiene acceso a la ruta:', rutaNormalizada);
        
        if (redirigirSiNoTieneAcceso) {
          this.toastr.error('No tienes permisos para acceder a esta pantalla');
          this.router.navigate(['/dashboard']);
        }
      } else {
        console.log('[Util] Usuario tiene acceso a la ruta:', rutaNormalizada);
      }
      
      return tieneAcceso;
    } catch (error) {
      console.error('[Util] Error al verificar acceso a pantalla:', error);
      if (redirigirSiNoTieneAcceso) {
        this.router.navigate(['/dashboard']);
      }
      return false;
    }
  }

  /**
   * Busca recursivamente una ruta en la estructura del menú
   * @param menuItems - Array de items del menú
   * @param rutaBuscada - Ruta normalizada a buscar
   * @returns true si encuentra la ruta, false si no
   */
  private buscarRutaEnMenu(menuItems: any[], rutaBuscada: string): boolean {
    if (!menuItems || !Array.isArray(menuItems)) {
      return false;
    }

    for (const item of menuItems) {
      // Verificar si este item tiene una ruta (type === 'link')
      if (item.type === 'link' && item.path && Array.isArray(item.path)) {
        // Construir la ruta completa del item
        const rutaItem = this.construirRutaCompleta(item.path);
        const rutaItemNormalizada = this.normalizarRuta(rutaItem);
        
        // Comparar rutas
        if (rutaItemNormalizada === rutaBuscada) {
          return true;
        }
        
        // También verificar si la ruta actual es una sub-ruta del item (ej: /catalogos/empresa/1)
        if (rutaBuscada.startsWith(rutaItemNormalizada + '/')) {
          return true;
        }
      }
      
      // Buscar recursivamente en los children
      if (item.children && Array.isArray(item.children) && item.children.length > 0) {
        if (this.buscarRutaEnMenu(item.children, rutaBuscada)) {
          return true;
        }
      }
    }
    
    return false;
  }

  /**
   * Construye la ruta completa desde un array de paths
   * @param pathArray - Array con segmentos de ruta (ej: ['/', 'catalogos', 'empresa'])
   * @returns Ruta completa (ej: '/catalogos/empresa')
   */
  private construirRutaCompleta(pathArray: string[]): string {
    if (!pathArray || pathArray.length === 0) {
      return '';
    }
    
    // Si es un solo elemento, retornarlo
    if (pathArray.length === 1) {
      return pathArray[0];
    }
    
    // Unir los elementos del array
    let ruta = pathArray.join('/');
    
    // Normalizar slashes dobles
    ruta = ruta.replace(/\/+/g, '/');
    
    // Asegurar que empiece con /
    if (!ruta.startsWith('/')) {
      ruta = '/' + ruta;
    }
    
    return ruta;
  }

  /**
   * Normaliza una ruta eliminando trailing slash, query params, fragments, etc.
   * @param ruta - Ruta a normalizar
   * @returns Ruta normalizada
   */
  private normalizarRuta(ruta: string): string {
    if (!ruta) {
      return '';
    }
    
    // Eliminar query parameters (?key=value)
    ruta = ruta.split('?')[0];
    
    // Eliminar fragments (#section)
    ruta = ruta.split('#')[0];
    
    // Eliminar trailing slash
    if (ruta.endsWith('/') && ruta.length > 1) {
      ruta = ruta.slice(0, -1);
    }
    
    // Asegurar que empiece con /
    if (!ruta.startsWith('/')) {
      ruta = '/' + ruta;
    }
    
    return ruta.toLowerCase();
  }

  /**
   * Verifica el acceso a la ruta actual del router
   * Úsalo en el constructor o ngOnInit de tus componentes
   * @param redirigir - Si debe redirigir automáticamente cuando no tiene acceso
   * @returns true si tiene acceso, false si no
   * 
   * @example
   * constructor(private util: Util) {
   *   this.util.verificarAccesoRutaActual(true);
   * }
   */
  verificarAccesoRutaActual(redirigir: boolean = true): boolean {
    const rutaActual = this.router.url;
    return this.verificarAccesoPantalla(rutaActual, redirigir);
  }

  /**
   * Obtiene la lista de rutas disponibles para el usuario desde el menú
   * @returns Array con las rutas a las que el usuario tiene acceso
   */
  obtenerRutasDisponibles(): string[] {
    const menuStr = localStorage.getItem('menu');
    
    if (!menuStr) {
      return [];
    }

    try {
      const menu = JSON.parse(menuStr);
      const rutas: string[] = [];
      
      this.extraerRutasDelMenu(menu, rutas);
      
      return rutas;
    } catch (error) {
      console.error('[Util] Error al obtener rutas disponibles:', error);
      return [];
    }
  }

  /**
   * Extrae recursivamente todas las rutas del menú
   * @param menuItems - Items del menú
   * @param rutas - Array donde se acumularán las rutas
   */
  private extraerRutasDelMenu(menuItems: any[], rutas: string[]): void {
    if (!menuItems || !Array.isArray(menuItems)) {
      return;
    }

    for (const item of menuItems) {
      if (item.type === 'link' && item.path && Array.isArray(item.path)) {
        const rutaCompleta = this.construirRutaCompleta(item.path);
        if (rutaCompleta) {
          rutas.push(rutaCompleta);
        }
      }
      
      if (item.children && Array.isArray(item.children)) {
        this.extraerRutasDelMenu(item.children, rutas);
      }
    }
  }
  
}
